import { Typography, IconButton, makeStyles, Select, MenuItem, SelectChangeEvent, InputLabel, FormControl} from "@material-ui/core";
import { Check, Close, NearMe } from "@material-ui/icons";
import { MapModes } from "../../../../constants/general";
import { useState, useEffect } from "react";
import { useDispatch } from 'react-redux';
import {setRouteStartPoint} from "../../../../reducers/mapMarkerSlice"
import { useToken } from "../../../../utilities/hooks";
import { useTranslation } from "react-i18next";

import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    spacing: {
        paddingLeft: theme.spacing(1)
    }
}));

function StartEndLocation(props) {
    const tokenContents = useToken();
    const userUS = tokenContents.userUS;
    const {t} = useTranslation('mapManagement');
    const dispatch = useDispatch();
    const classes = useStyles();
    const { startLocation, endLocation, mapMode, handleMapModeChange, containerStyle } = props
    const [pickUpPointId, setPickUpPointId] = useState('');
    console.log(userUS);

    const pickUpPoints = [
        {
            id: 0,
            name: '0 - None',
            lat: -1,
            lng: -1,
        },
        {
            id: 1,
            name: '1 - Gardena',
            lat: 33.90041832620283,
            lng: -118.26364649811518,
        },
        {
            id: 2,
            name: '2 - Buena Park',
            lat: 33.8570912711198,
            lng: -118.01184492727467,
        },
        {
            id: 3,
            name: '3 - Alhambra',
            lat: 34.06948508447148,
            lng: -118.15140708526489,
        },
        {
            id: 4,
            name: '4 - City of Industry',
            lat: 34.01986209345068,
            lng: -117.95977336128313,
        },
    ];

    const handleChange = (event) => {
        setPickUpPointId(event.target.value);
    };

    useEffect(() => {
        let pickUpPoint = _.find(pickUpPoints, { 'id': pickUpPointId });
        if (pickUpPointId !== 0 && pickUpPoint) {
            let lat = pickUpPoint.lat;
            let lng = pickUpPoint.lng;
            dispatch(setRouteStartPoint({ lat, lng }));
            handleMapModeChange(MapModes.SELECT_END);
        } else {
            dispatch(setRouteStartPoint(null));
        }
    }, [pickUpPointId]);

    return (
        <div className={containerStyle}>
            <div style={{ display: 'flex' }}>
                <div
                    style={{ display: 'flex', paddingTop: '20px' }}
                >
                    {isStartSet() ? <Check color='primary' /> : <Close color='error' />}
                    <Typography
                        className={classes.spacing}
                    >
                        {t('start_location')}</Typography>
                    <IconButton
                        className={classes.spacing}
                        size='small'
                        color={mapMode === MapModes.SELECT_START ? 'secondary' : 'default'}
                        onClick={() => handleMapModeChange(MapModes.SELECT_START)}
                    >
                        <NearMe
                            style={{ paddingBottom: "20px" }} />
                    </IconButton>
                </div>
                {
                    userUS &&
                    <FormControl>
                        <InputLabel id="routeplanner_pickuppoint_selectlable">{t('select_start_point')}</InputLabel>
                        <Select
                            labelId="routeplanner_pickuppoint_selectlable"
                            style={{ width: "150px" }}
                            value={pickUpPointId}
                            onChange={handleChange}
                        >
                            {pickUpPoints?.map((point) => {
                                return <MenuItem value={point.id}>{point.name}</MenuItem>
                            })}
                        </Select>
                    </FormControl>
                }
            </div>
            <div style={{ display: 'flex' }}>
                {isEndSet() ? <Check color='primary' /> : <Close color='error' />}
                <Typography className={classes.spacing}>{t('end_location')}</Typography>
                <IconButton
                    className={classes.spacing}
                    size='small'
                    color={mapMode === MapModes.SELECT_END ? 'secondary' : 'default'}
                    onClick={() => handleMapModeChange(MapModes.SELECT_END)}
                >
                    <NearMe />
                </IconButton>
            </div>
        </div>
    )

    function isStartSet() {
        if(startLocation != null){
            return true
        } else {
            return false
        }
    }

    function isEndSet(){
        if(endLocation !== null){
            return true
        } else {
            return false
        }
    }
}

export default StartEndLocation